var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAgency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.5774,
    y1: 313.7939,
    x2: 203.4063,
    y2: 313.7939,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M194.965,124.03c7.293-2.991,11.08-11.067,8.743-18.596l-0.176-0.567 c-2.655-8.555-12.079-12.979-20.367-9.577c-30.631,12.572-57.996,33.182-78.587,59.299l-38.332,10.717 c-7.743,2.164-9.822,12.163-3.584,17.235l16.845,13.697c-10.645,24.182-16.168,50.38-16.168,77.443c0,7.254,0.406,14.503,1.21,21.68 c0.998,8.9,9.383,15.051,18.163,13.284l0.58-0.116c7.798-1.57,12.997-8.866,12.118-16.772c-0.666-5.981-1-12.024-1-18.076 c0-19.749,3.501-38.948,10.287-56.96l6.148,5c6.238,5.073,15.602,0.998,16.142-7.024l2.824-41.951 C147.007,151.309,169.669,134.401,194.965,124.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.63,
    y1: 69.5434,
    x2: 370.9862,
    y2: 69.5434,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M368.72,409.062c-5.098-6.115-13.994-7.203-20.532-2.661 c-18.216,12.651-38.868,21.393-60.548,25.727l-0.1-14.335c-0.056-8.039-9.158-12.671-15.69-7.983l-34.038,24.427 c-26.564-3.017-52.05-12.59-74.001-27.836c-6.539-4.542-15.434-3.452-20.532,2.661l-0.377,0.453 c-5.727,6.869-4.334,17.17,3.006,22.28c27.842,19.382,60.46,31.098,94.324,33.889l32.167,22.41 c6.597,4.596,15.633-0.162,15.577-8.202l-0.113-16.219c28.054-4.713,54.829-15.587,78.231-31.878c7.34-5.11,8.733-15.41,3.006-22.28 L368.72,409.062z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.2104,
    y1: 313.7944,
    x2: 446.7166,
    y2: 313.7944,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M433.416,198.351l3.922-36.832c0.851-7.995-7.669-13.623-14.688-9.703l-12.132,6.776 c-0.057-0.076-0.112-0.155-0.17-0.232c-20.888-27.914-49.417-49.899-81.513-63.071c-8.287-3.401-17.711,1.022-20.367,9.577 l-0.177,0.567c-2.336,7.528,1.451,15.605,8.743,18.596c25.749,10.558,48.755,27.898,66.058,49.881l-14.66,8.188 c-7.019,3.92-6.695,14.127,0.558,17.595l38.884,18.589c6.407,17.558,9.715,36.217,9.715,55.396c0,6.052-0.335,12.094-1,18.076 c-0.879,7.907,4.319,15.202,12.118,16.772l0.58,0.116c8.779,1.767,17.165-4.384,18.163-13.284c0.805-7.178,1.21-14.425,1.21-21.68 C448.662,247.405,443.461,221.942,433.416,198.351z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.3285,
    y1: 358.2459,
    x2: 347.9185,
    y2: 365.4659,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M348.539,104.752c1.956,7.617,2.996,15.6,2.996,23.826c0,4.795-0.357,9.505-1.039,14.109 c12.217,8.831,23.246,19.341,32.598,31.223l-14.66,8.188c-7.019,3.92-6.695,14.127,0.558,17.595l2.119,1.013 c11.744-18.703,19.054-40.468,20.463-63.828C378.782,124.244,364.254,113.404,348.539,104.752z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.1184,
    y1: 72.1258,
    x2: 182.7684,
    y2: 85.1858,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M225.977,432.428c-13.587-2.573-26.783-6.872-39.248-12.78 c-5.89,9.104-13.286,17.139-21.835,23.759c13.158,7.055,27.095,12.556,41.513,16.398 C214.002,451.555,220.593,442.367,225.977,432.428z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.7455,
    y1: 196.2802,
    x2: 219.9225,
    y2: 34.1001,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7ECCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FA9F5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    cx: 106.466,
    cy: 367.82,
    r: 106.466
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.6486,
    y1: 196.2762,
    x2: 517.8286,
    y2: 34.0962,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    cx: 405.534,
    cy: 367.82,
    r: 106.466
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.6982,
    y1: 434.5869,
    x2: 368.8782,
    y2: 272.4059,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E24786"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    cx: 256,
    cy: 128.575,
    r: 106.466
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.8186,
    y1: 323.6562,
    x2: 261.3986,
    y2: 417.0762,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E24786"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M361.964,138.846c-2.078,21.885-10.802,41.843-24.124,57.826 c-5.261,6.315-11.234,12.017-17.81,16.956l-73.507-73.507l-18.492-18.492c-8.192-7.549-13.332-18.372-13.332-30.389 c0-22.809,18.492-41.301,41.301-41.301c12.017,0,22.839,5.14,30.389,13.332L361.964,138.846z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.5786,
    y1: 262.7662,
    x2: 267.1286,
    y2: 323.2262,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E24786"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M337.84,196.671c-5.261,6.315-11.234,12.017-17.81,16.956 c-17.82,13.453-39.996,21.414-64.03,21.414c-3.012,0-5.993-0.12-8.945-0.382l-48.961-48.891 c5.22-23.532,24.415-41.793,48.429-45.648c3.092-0.492,6.254-0.753,9.477-0.753c16.384,0,31.212,6.646,41.944,17.378L337.84,196.671 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8086,
    y1: 442.6292,
    x2: 254.8086,
    y2: 371.2462,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    cx: 256,
    cy: 91.24,
    r: 41.301
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8086,
    y1: 356.7662,
    x2: 254.8086,
    y2: 295.7562,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M313.906,185.769c-14.748,14.948-35.248,24.205-57.906,24.205 c-22.659,0-43.159-9.256-57.906-24.205c5.893-26.554,29.576-46.401,57.906-46.401c16.384,0,31.212,6.646,41.944,17.378 C305.774,164.566,311.427,174.575,313.906,185.769z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 488.2896,
    y1: 100.8272,
    x2: 394.8796,
    y2: 194.2372,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FC7E2",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4975AD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M511.502,378.092c-2.078,21.885-10.802,41.843-24.124,57.826 c-5.261,6.315-11.234,12.017-17.81,16.956l-73.507-73.507l-18.492-18.492c-8.192-7.549-13.332-18.372-13.332-30.389 c0-22.809,18.492-41.301,41.301-41.301c12.017,0,22.839,5.14,30.389,13.332L511.502,378.092z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.9716,
    y1: 46.8976,
    x2: 405.5216,
    y2: 107.3576,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FC7E2",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4975AD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "M487.378,435.918c-5.261,6.315-11.234,12.017-17.81,16.956 c-17.82,13.453-39.996,21.414-64.03,21.414c-3.012,0-5.993-0.12-8.945-0.382l-48.961-48.891 c5.22-23.532,24.415-41.793,48.429-45.648c3.092-0.492,6.254-0.753,9.477-0.753c16.384,0,31.212,6.646,41.944,17.378 L487.378,435.918z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.7586,
    y1: 204.3162,
    x2: 403.7586,
    y2: 132.9362,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    cx: 405.534,
    cy: 330.484,
    r: 41.301
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.7626,
    y1: 118.4562,
    x2: 403.7626,
    y2: 57.4462,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    d: "M463.444,425.015c-14.748,14.948-35.248,24.205-57.906,24.205 c-22.659,0-43.159-9.256-57.906-24.205c5.893-26.554,29.576-46.401,57.906-46.401c16.384,0,31.212,6.646,41.944,17.378 C455.313,403.813,460.965,413.822,463.444,425.015z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.8552,
    y1: 85.3428,
    x2: 112.4452,
    y2: 178.7628,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7ECCFD",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FA9F5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    d: "M212.426,378.092c-2.078,21.885-10.802,41.843-24.124,57.826 c-5.261,6.315-11.234,12.017-17.81,16.956l-73.507-73.507l-18.492-18.492c-8.192-7.549-13.332-18.372-13.332-30.389 c0-22.809,18.492-41.301,41.301-41.301c12.017,0,22.839,5.14,30.389,13.332L212.426,378.092z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.6328,
    y1: 24.4582,
    x2: 118.1728,
    y2: 84.9182,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7ECCFD",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FA9F5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_18_)"
    },
    d: "M188.302,435.918c-5.261,6.315-11.234,12.017-17.81,16.956 c-17.82,13.453-39.996,21.414-64.03,21.414c-3.012,0-5.993-0.12-8.945-0.382l-48.961-48.891 c5.22-23.532,24.415-41.793,48.429-45.648c3.092-0.492,6.254-0.753,9.477-0.753c16.384,0,31.212,6.646,41.944,17.378 L188.302,435.918z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.8586,
    y1: 204.3162,
    x2: 105.8586,
    y2: 132.9362,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_19_)"
    },
    cx: 106.466,
    cy: 330.484,
    r: 41.301
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.8546,
    y1: 118.4562,
    x2: 105.8546,
    y2: 57.4462,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_20_)"
    },
    d: "M164.368,425.015c-14.748,14.948-35.248,24.205-57.906,24.205s-43.159-9.256-57.906-24.205 c5.893-26.554,29.576-46.401,57.906-46.401c16.384,0,31.212,6.646,41.944,17.378C156.236,403.813,161.888,413.822,164.368,425.015z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgency);
export default __webpack_public_path__ + "static/media/icon-agency.214aa5d4e459dc54d30f89284dc82074.svg";
export { ForwardRef as ReactComponent };